/**
 * Axios Headers Fix Plugin
 * 
 * This plugin ensures that axios request config always has a headers object
 * to prevent "Cannot read properties of undefined (reading 'Authorization')"
 * errors in @nuxtjs/auth-next module.
 * 
 * Must be loaded BEFORE the auth module processes requests.
 */
export default function ({ $axios }) {
  if (!$axios) return;

  // Normalize headers so axios never sends nested keys as literal headers
  $axios.interceptors.request.use(
    (config) => {
      if (!config.headers) {
        config.headers = {};
      }

      const method = (config.method || 'get').toLowerCase();

      // Flatten axios-style nested headers into a plain header map
      if (config.headers.common && typeof config.headers.common === 'object') {
        config.headers = {
          ...config.headers.common,
          ...config.headers,
        };
      }

      if (config.headers[method] && typeof config.headers[method] === 'object') {
        config.headers = {
          ...config.headers[method],
          ...config.headers,
        };
      }

      // Remove nested buckets so they are never sent as literal headers
      delete config.headers.common;
      delete config.headers.get;
      delete config.headers.post;
      delete config.headers.put;
      delete config.headers.patch;
      delete config.headers.delete;
      delete config.headers.head;
      delete config.headers.options;

      return config;
    },
    (error) => Promise.reject(error)
  );
}
